var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Disclaimer',{attrs:{"slice":_vm.slices[0]}})}
var staticRenderFns = []

export { render, staticRenderFns }